<template>
	<div class="w-full">
		<div>
			<div>
				<div class="__report-lesson pb-30">
					<div class="
							__breadcrumbs
							text-sm text-neutral-500
							font-semibold
							flex-nowrap flex
							items-center
							justify-between
						">
						<div class="flex items-center">
							<router-link :to="{
								name: 'form_evaluation_for_student_lib_create',
							}">
								Thư Viện Nội Bộ
							</router-link>
							<div class="__breadcrumbs__decorate">
								<DaIcon name="das--chevron-down" class="transform -rotate-90 h-3 w-3 mx-2" />
							</div>
							<div>{{ goal.name }}</div>
						</div>
					</div>
					<div class="
							mt-6
							__report-lesson__header
							flex flex-nowrap
							justify-between
							items-center
							w-full
							gap-4
						">
						<div class="
								__record__title
								text-neutral-500
								font-semibold
								whitespace-wrap
								flex flex-nowrap
								items-start
								text-4xl
								gap-4
								justify-between
								w-full
							">
							<div>
								<div class="flex items-center gap-4">
									<router-link :to="{
										name: 'form_evaluation_for_student_lib_create',
									}">
										<svg class="cursor-pointer" width="28" height="28" viewBox="0 0 28 28"
											fill="none" xmlns="http://www.w3.org/2000/svg">
											<path d="M17.5 7L10.5 14L17.5 21" stroke="#94A3B8" stroke-width="2"
												stroke-linecap="round" stroke-linejoin="round" />
										</svg>
									</router-link>

									<svg width="28" height="28" viewBox="0 0 28 28" fill="none"
										xmlns="http://www.w3.org/2000/svg" class="mb-1">
										<path
											d="M25.4998 5.98259H11.021C10.7609 5.98259 10.5219 5.8514 10.3931 5.63913L9.104 3.51831C8.65802 2.78525 7.83103 2.33337 6.93503 2.33337H2.5C1.11897 2.33337 0 3.38904 0 4.69193V22.1415C0 23.4444 1.11897 24.5 2.5 24.5H25.5C26.881 24.5 28 23.4444 28 22.1415V8.34109C28 7.03906 26.881 5.98253 25.5 5.98253L25.4998 5.98259ZM4.09697 16.1387H6.65903C7.15613 16.1387 7.55903 16.5188 7.55903 16.9878C7.55903 17.4567 7.15613 17.8368 6.65903 17.8368H4.09697C3.59987 17.8368 3.19697 17.4567 3.19697 16.9878C3.19697 16.5188 3.59987 16.1387 4.09697 16.1387ZM10.437 21.1483H4.09697C3.59987 21.1483 3.19697 20.7682 3.19697 20.2992C3.19697 19.8303 3.59987 19.4501 4.09697 19.4501H10.4381C10.9352 19.4501 11.3381 19.8303 11.3381 20.2992C11.3379 20.768 10.935 21.1483 10.437 21.1483Z"
											fill="#94A3B8" />
									</svg>
									<span>{{ goal.name }}</span>
								</div>
							</div>
						</div>
						<button class="
								delete-button
								flex
								items-center
								whitespace-nowrap
							" :class="{
								'disable-button': goalsSelected.length == 0,
							}" @click="addMultiGoal">
							Thêm mục tiêu đã chọn
						</button>
					</div>
					<div class="mt-2">
						<div v-if="!isDataLoading">
							<div v-if="folders.length">
								<div v-for="folder in folders" :key="folder.id">
									<GoalFolderItem :is-edit="false" :data="folder" :skills="skills"
										:selected-goal="selected" @action-clicked="doGoal" :isInCreateGoal="true"
										:formCreate="true">
										<template v-slot:actions>
											<div></div>
										</template>
									</GoalFolderItem>
								</div>
							</div>
							<div v-else class="
									w-full
									h-full
									flex
									items-center
									justify-center
									flex-col
								">
								<img src="@/assets/images/illustrations/not_found.png" alt="" height="250"
									width="250" />
								<div class="text-neutral-400 text-lg text-center" style="max-width: 900px">
									Chưa có thư mục hay mục tiêu nào trong thư
									viện này.
									<br /><br />
									Nếu ngân hàng của bạn gồm nhiều mục tiêu
									được chia theo lĩnh vực hoặc chia theo độ
									tuổi hoặc theo vấn đề của trẻ thì bạn nên
									tạo Thư mục trước khi tạo Mục tiêu.
								</div>
							</div>
						</div>
						<div v-else class="fixed top-1/2 left-1/2">
							<Loading />
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import DaIcon from '@/components/elements/daIcon/DaIcon';
import GoalFolderItem from '@/views/goalFolders/features/GoalFolderItem';
import Loading from '@/components/common/Loading';
import { $api } from '@/services';
import FormCreate from '@/views/formCreate/FormCreate.vue';

export default {
	name: 'CreateGoalByLibGoals',
	components: {
		Loading,
		GoalFolderItem,
		DaIcon,
	},
	data() {
		return {
			isLoading: true,
			goal: {
				id: '',
				name: '',
				created_by_staff: {
					name: '',
				},
				last_updated_at: null,
			},
			inProgress: false,
			skills: [],
			isDataLoading: true,
			error: '',
			tabActive: 0,
			folders: [],
			selected: [],
		};
	},

	created() {
		this.$store.dispatch('clearSelected');
		this.fetchGoalLib();
		this.fetchSkill();
		this.fetchGoalFolders();
	},

	computed: {
		lId() {
			return this.$route?.params?.lId || '';
		},

		isAdmin() {
			return this.$store.getters.isAdmin;
		},

		studentId() {
			return this.$route?.params?.id || '';
		},

		goalsSelected() {
			const s = this.$store.getters.goalsSelected;
			return (s || []).map((i) => i.id);
		},
	},

	methods: {
		updated() {
			this.selected.push(this.goalPayloadData?.id);
			// this.fetchGoalFolders();
			this.$emit('updated');
		},

		async addMultiGoal() {
			try {
				await $api.form.addGoalFromLib(this.studentId, {
					library_item_ids: this.goalsSelected,
					state: 'assessment_form',
					student_assessment_form_id: Number(
						this.$route.params.formId
					),
				});
				this.$store.dispatch('setAlertMessage', {
					message: 'Đã thêm mục tiêu thành công',
				});
				for (let i in this.goalsSelected) {
					this.$store.dispatch('taughtGoal', i);
				}
				this.$emit('success');
			} catch (e) {
				this.$store.dispatch('setAlertMessage', {
					message:
						e?.response?.data?.errors?.join('<br/>') ||
						'Đã có lỗi xảy ra. Vui lòng thử lại',
					type: 'danger',
				});
			}
		},
		async fetchSkill() {
			try {
				const {
					data: { data },
				} = await $api.goal.allSkills(this.isAdmin);
				if (data) {
					this.skills = data;
				}
			} catch (e) {
				console.log(e);
			}
		},

		async fetchGoalFolders() {
			try {
				const {
					data: { data },
				} = await $api.goal.fetchAllGoalFolders(
					this.lId,
					{ student_assessment_form_id: this.studentId },
					this.isAdmin, true
				);
				this.folders = data;
			} catch (e) {
				this.$store.dispatch('setAlertMessage', {
					message:
						e?.response?.data?.errors?.join('<br/>') ||
						'Đã có lỗi xảy ra. Vui lòng thử lại',
					type: 'danger',
				});
			} finally {
				this.isDataLoading = false;
			}
		},

		async fetchGoalLib() {
			try {
				const {
					data: { data },
				} = await $api.goal.fetchGoalLibDetail(this.lId, this.isAdmin);
				this.goal = data;
			} catch (e) {
				this.$store.dispatch('setAlertMessage', {
					message:
						e?.response?.data?.errors?.join('<br/>') ||
						'Đã có lỗi xảy ra. Vui lòng thử lại',
					type: 'danger',
				});
			}
		},

		async doGoal(goal) {
			try {
				const res = await $api.form.addGoalFromLib(this.studentId, {
					library_item_ids: [goal.id],
					state: 'assessment_form',
					student_assessment_form_id: Number(
						this.$route.params.formId
					),
				});
				if (res.data) {
					this.$store.dispatch('setAlertMessage', {
						message: 'Thêm mục tiêu thành công',
					});
					this.$store.dispatch('taughtGoal', goal.id);
					this.$emit('success');
				}
			} catch (e) {
				await this.$store.dispatch('setAlertMessage', {
					message:
						e?.response?.data?.errors?.join('<br/>') ||
						'Đã có lỗi xảy ra. Vui lòng thử lại',
					type: 'danger',
				});
			}
		},
	},
};
</script>
<style scoped>
.delete-button {
	padding: 12px 20px;
	gap: 6px;
	border-radius: 4px;
	border: 1px solid #d89210;
	font-size: 14px;
	font-weight: 600;
	line-height: 20px;
	color: #d89210;
}

.disable-button {
	background: #e1e7ef !important;
	border: 1px solid #cbd5e1 !important;
	color: #cbd5e1;
}
</style>
